import { BASE_SIZE, BASE_VARIANT } from '../constant';

const { XS, SM, MD, LG, XL: _ } = BASE_SIZE;

export const BUTTON_SIZE = { XS, SM, MD, LG } as const;

export const BUTTON_VARIANT = {
  PRIMARY: BASE_VARIANT.PRIMARY,
  SECONDARY: BASE_VARIANT.SECONDARY,
  DANGER: BASE_VARIANT.DANGER,
  CANCEL: 'cancel',
  /** @deprecated outline 붙은 variant 는 사용하지 말것 */
  DANGER_OUTLINE: 'dangerOutline',
  TRANSPARENT: 'transparent',
} as const;
